import { render, staticRenderFns } from "./OwnerNotificationPostPage.vue?vue&type=template&id=144af11a&scoped=true&"
import script from "./OwnerNotificationPostPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerNotificationPostPage.vue?vue&type=script&lang=ts&"
import style0 from "./OwnerNotificationPostPage.vue?vue&type=style&index=0&id=144af11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144af11a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
